interface ThumbsUpIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  /** Stroke/outline color; defaults to #7A7A7A when not provided */
  color?: string;
}

const DEFAULT_STROKE = "#7A7A7A";

export function ThumbsUpIcon({
  className,
  width = "16",
  height = "16",
  color,
}: ThumbsUpIconProps) {
  const stroke = color ?? DEFAULT_STROKE;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_thumbs_up_icon)">
        <path
          d="M4.08398 5.83203V12.832"
          stroke={stroke}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.74935 3.4313L8.16602 5.83464H11.5668C11.748 5.83464 11.9266 5.8768 12.0886 5.9578C12.2506 6.0388 12.3915 6.15641 12.5002 6.3013C12.6089 6.4462 12.6823 6.6144 12.7147 6.7926C12.7471 6.9708 12.7376 7.15409 12.6868 7.32797L11.3277 11.9946C11.257 12.237 11.1096 12.4498 10.9077 12.6013C10.7057 12.7528 10.4601 12.8346 10.2077 12.8346H2.33268C2.02326 12.8346 1.72652 12.7117 1.50772 12.4929C1.28893 12.2741 1.16602 11.9774 1.16602 11.668V7.0013C1.16602 6.69188 1.28893 6.39514 1.50772 6.17634C1.72652 5.95755 2.02326 5.83464 2.33268 5.83464H3.94268C4.15973 5.83452 4.37244 5.77386 4.55691 5.65947C4.74137 5.54509 4.89026 5.38151 4.98685 5.18714L6.99935 1.16797C7.27444 1.17138 7.5452 1.2369 7.7914 1.35965C8.03761 1.4824 8.25289 1.6592 8.42117 1.87684C8.58945 2.09448 8.70637 2.34733 8.7632 2.6165C8.82002 2.88568 8.81529 3.16421 8.74935 3.4313Z"
          stroke={stroke}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_thumbs_up_icon">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
